import { Grid } from "@mui/material";
import { styled } from "@mui/material/styles";

export const UnloadModalWrapper = styled(Grid)(() => ({
  paddingBottom: "1.2rem",
  gap: "12px",
}));

export const OrdersOptions = styled("li")(() => ({
  display: "flex",
  alignItems: "center",
  gap: "12px",
}));

export const WarningWrapper = styled(Grid)(() => ({
  display: "flex",
  padding: "12px 24px 12px 8px",
  alignItems: "flex-start",
  gap: "8px",
  borderRadius: "8px",
  background: "#FFFCF5",
  width: "100%",
}));

export const WarningIconContainer = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: "8px",
  borderRadius: "32px",
  background: "#FFFAEB",
}));

export const WarningTextContainer = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
}));

export const WarningTitle = styled("span")(() => ({
  color: "#AA5103",
  fontFamily: "Manrope",
  fontSize: "12px",
  fontWeight: 500,
  lineHeight: "160%",
}));

export const WarningText = styled("span")(() => ({
  color: "#AA5103",
  fontFamily: "Manrope",
  fontSize: "12px",
  fontWeight: 300,
  lineHeight: "160%",
}));
